import { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, Input, InputNumber, Cascader, Select, message } from 'antd';
import { phoneRegExp } from '@/utils/regular';
import { fetchAllList } from '@/services';
import {addClue} from '@/services/callCenter'

import arrToListOption from '@/utils/arrToListOption'

import {SDrawerOrModal, STriggerModal} from 'shj-components';
import { isArray } from 'lodash-es';
import {getUser} from "@/common/utils.ts";
import {getBusinessLines} from "@/services/getUsers.ts";
import {getCustomerSource} from "@/services/customerServices.ts";
import {getDispatchMnrList} from "@/services/saleOpServices.ts";
import {trimStr} from "@/utils/data.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import {getEnums} from "@/services/homeService.ts";
import {getChannelMarkListByChannelId} from "@/services/channelManagement.ts";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;

function AddClueModal(props: any) {
  const userInfo = getUser()
  const addForm = useRef<any>();
  const [form] = Form.useForm();
  const { onCancel, open, fn , isEdit} = props;
  const [loading, setLoading] = useState(false);
  const [signData, setSignData] = useState<any[]>([]); // 渠道标记
  const [refreshSign, setRefreshSign] = useState(false);
  const [cityArea, setCityArea] = useState<any[]>([]); // 报名城市
  const [companyList, setCompanyList] = useState<any[]>([]); // 分公司
  const [sourceChannelList, setSourceChannelList] = useState<any[]>([]) //房屋属性;
  const [bizOpPropertyTypeList, setBizOpPropertyTypeList] = useState<any[]>([])//客户来源;
  const [brandCodeList, setBrandCodeList] = useState<any[]>([]); // 业务线
  const [armyAffiliationList, setArmyAffiliationList] = useState<any[]>([]); // 总分归属
  const [ykfList, setYkfCodeList] = useState<any[]>([]); // 云客服
  const [anchor, setAnchor] = useState<any[]>([]); // 主播
  const [advert, setAdvert] = useState<any[]>([]); // 优化师
  const [liveOperation, setLiveOperation] = useState<any[]>([]); // 直播运营

  useEffect(() => {
    onReset()
    fetchPullDown();
  }, []);

  useEffect(() => {
    if(isEdit) {
      form.setFieldsValue({
        ...props.detail
      })
    }
  }, [isEdit]);

  // 获取其余下拉列表数据
  const fetchPullDown = () => {
    // 业务线
    getBusinessLines().then((res) => {
      setBrandCodeList(res);
    })
    // 总分归属
    getEnums(
        "dispatcher",
        "com.shj.saas.plus.clue.enums.ArmyAffiliation",
    ).then((res) => {
      setArmyAffiliationList(res);
    })
    //  获取分公司
    fetchAllList("company").then((res) => {
      setCompanyList(res);
    })
    getUserIdentityFn( ['ykf']).then(res => {
      setYkfCodeList(res)
    })

    getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum').then(res => {
      console.log('房屋属性枚举------->', res)
      setBizOpPropertyTypeList(res || [])
    })

    getCustomerSource({[isEdit ? '' : 'state']: 'CHECKED'}).then((channelList) => {
      // console.log('fetchCustomerSource', channelList)
      setSourceChannelList(channelList || [])
    })
  };

  useEffect(() => {
    // 获取渠道标记
    if (form.getFieldValue('channelId')) fetchSignData(form.getFieldValue('channelId'));
  }, [refreshSign]);
  // 根据客户来源的id更新
  const fetchSignData = (id: any) => {
    setSignData([])
    setLoading(true)
    const channelId = id[id.length - 1] || '';
    if (!channelId) return;
    getChannelMarkListByChannelId(channelId).then((res: any) => {
      const list = res || []
      if (!list.length) message.warning('当前来源暂无渠道标记');
      setSignData([...list]);

    }).finally(() => setLoading(false));
  };

  // 表单更新时
  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.channelId) {
      setRefreshSign(!refreshSign); //刷新渠道标记
      }
  };

  const onSubmit = (values: any) => {
    const data = { ...values, clueSource: 'MANUAL' };
    // if (data.signId) {
    //   //获取渠道标记中文名
    //   const list = signData.filter((d: any) => d.id == data.signId);
    //   if (list.length) data.signName = list[0].markName;
    // }
    if (data.isDispatch) {
      //修改是否派单正确值
      data.isDispatch = { '1': true, '-1': false }[data.isDispatch];
    }
    if (data.channelId) {
      //修改客户来源正确值
      data.channelId = data.channelId[data.channelId.length - 1];
    }
    // if (data.anchorWorkerNumber) {
    //   const anchor = data.anchorWorkerNumber.split('-');
    //   data.anchorName = anchor[0];
    //   data.anchorWorkerNumber = anchor[1];
    // }
    // if (data.liveOperationWorkerNumber) {
    //   const liveOperation = data.liveOperationWorkerNumber.split('-');
    //   data.liveOperationName = liveOperation[0];
    //   data.liveOperationWorkerNumber = liveOperation[1];
    // }
    // if (data.advertWorkerNumber) {
    //   const advert = data.advertWorkerNumber.split('-');
    //   data.advertWorkerName = advert[0];
    //   data.advertWorkerNumber = advert[1];
    // }
    setLoading(true);
    addClue({ ...data, clueSource: 'CALL_PAGE' })
      .then((res: any) => {
        message.success('操作成功');
        form.resetFields();
        fn && fn()
        onCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCity = (data) => {
    const obj = {}
    return data.reduce((res, item) => {
     if(!obj[item.cityCode]) {
       res.push(item)
     }
     obj[item.cityCode] = true
     return res;
    }, [])
  }

  const onCompanyCodeChange = (val: string) => {
    const orgId = addForm.current.getFieldValue('orgId');
    setAnchor([]);
    setAdvert([]);
    setLiveOperation([]);
    // getCustomerSourceByCompony(val).then(res => {
    //   setSourceChannelList(res || [])
    // })
    // 报名城市
    getDispatchMnrList({storeId: val})
      .then((res: any) => {
        setCityArea(handleCity(res || []));
      })
      .catch(() => {
        setCityArea([])
      });
    if (orgId) {
      getAnchorFn( 'ANCHOR', orgId).then((res) => {
        setAnchor(res || [])
      })
      getAnchorFn( 'LIVE_OPERATION', orgId).then((res) => {
        setLiveOperation(res || [])
      })
      getAnchorFn( 'ADVERT', orgId).then((res) => {
        setAdvert(res || [])
      })
    }
  };
  const onFinish = () => {
    form.validateFields().then((values) => {
      onSubmit(values)
    })
  };
  const onReset = () => {
    form.resetFields();
  };
  const formItemLayout = {
    labelCol: {
      span: 6
    },
    wrapperCol: {
      span: 18
    },
  };

  return (
    <SDrawerOrModal
      title="云客服新增线索"
      mode={'drawer'}
      open={open}
      onCancel={onCancel}
      onOk={onFinish}
      loading={loading}
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        ref={addForm}
      >
        <Row gutter={12}>
          <Col span={12}>
            <FormItem
              label="客户来源"
              name="channelId"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Cascader
                placeholder="请选择"
                showSearch
                expandTrigger="hover"
                options={sourceChannelList}
              />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="渠道标记" name="channelTag">
              <Select placeholder="请选择" allowClear showSearch optionFilterProp="children">
                {arrToListOption(signData, { value: 'id', title: 'markName' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="品牌"
              name="channelBrandId"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select placeholder="请选择" allowClear showSearch optionFilterProp="children">
                {arrToListOption(brandCodeList, { value: 'id', title: 'brandName' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="总分归属"
              name="armyAffiliation"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select placeholder="请选择" allowClear showSearch optionFilterProp="description">
                {arrToListOption(armyAffiliationList, { value: 'key', title: 'description' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="客户姓名" name="name" rules={[{ required: true, message: '请输入' }]}>
              <Input placeholder="请输入客户姓名" onChange={(e) => form.setFieldValue('name', trimStr(e.target.value))}/>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="联系电话"
              name="phone"
              rules={[{ required: true, message: '请输入联系电话', pattern: phoneRegExp }]}
            >
              <InputNumber placeholder="请输入" style={{ width: '100%' }} step={0} min={0} />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="云客服"
              name="callUserId"
              rules={[{ required: false, message: '请输入' }]}
            >
              <Select
                  options={ykfList}
                  fieldNames={{label: 'userName', value: 'ucenterUserId'}}
                placeholder="请选择云客服"
                style={{ width: '100%' }}
                  onChange={(e,op) => {
                    form.setFieldValue('callUserName', op?.userName)
                    form.setFieldValue('callDeptId', op?.orgId)
                    form.setFieldValue('callOrgId', op?.companyId)
                  }}
              />
            </FormItem>
          </Col>
            <FormItem label="云客服" name="callUserName" hidden > <Input/> </FormItem>
            <FormItem label="云客服" name="callDeptId" hidden > <Input/> </FormItem>
            <FormItem label="云客服" name="callOrgId" hidden > <Input/> </FormItem>
          <Col span={12}>
            <FormItem
              label="房屋属性"
              name="houseNatureCode"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select placeholder="请选择" allowClear showSearch optionFilterProp="children">
                {arrToListOption(bizOpPropertyTypeList, { value: 'key', title: 'description' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="是否派单"
              name="isDispatch"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select placeholder="请选择" allowClear>
                <Option value="1">是</Option>
                <Option value="-1">否</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="分公司"
              name="orgId"
              rules={[{ required: true, message: '请选择' }]}
            >
              <Select
                placeholder="请选择"
                allowClear
                onChange={onCompanyCodeChange}
                showSearch
                optionFilterProp="children"
              >
                {arrToListOption(companyList, { value: 'id', title: 'name' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="报名城市"
              name="cityAreaCode"
              rules={[{ required: true, message: '请选择' }]}
              preserve={false}
            >
              <Select placeholder="请选择" allowClear showSearch optionFilterProp="children">
                {arrToListOption(cityArea, { value: 'cityCode', title: 'regionName' })}
              </Select>
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="主播" name="anchorEmployeeId">
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onChange={(e, op) => form.setFieldValue('anchorName', op?.children)}
                notFoundContent="请选择公司或暂无数据"
              >
                {isArray(anchor) &&
                  anchor.map((item, index) => (
                    <Select.Option
                      key={index + 'ucenterUserId'}
                      value={item['ucenterUserId']}
                      data={item}
                    >
                      {item['userName']}
                    </Select.Option>
                  ))}
              </Select>
            </FormItem>
            <FormItem label="主播" name="anchorName" hidden > <Input/> </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="直播运营" name="liveOperationEmployeeId">
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onChange={(e, op) => form.setFieldValue('liveOperationName', op?.children)}
                notFoundContent="请选择公司或暂无数据"
              >
                {isArray(liveOperation) &&
                  liveOperation.map((item, index) => (
                    <Select.Option
                      key={index + 'ucenterUserId'}
                      value={item['ucenterUserId']}
                      data={item}
                    >
                      {item['userName']}
                    </Select.Option>
                  ))}
              </Select>
            </FormItem>
            <FormItem label="直播运营" name="liveOperationName" hidden > <Input/> </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="优化师" name="advertEmployeeId">
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onChange={(e, op) => form.setFieldValue('advertName', op?.children)}
                notFoundContent="请选择公司或暂无数据"
              >
                {isArray(advert) &&
                  advert.map((item, index) => (
                    <Select.Option
                      key={index + 'ucenterUserId'}
                      value={item['ucenterUserId']}
                      data={item}
                    >
                      {item['userName']}
                    </Select.Option>
                  ))}
              </Select>
            </FormItem>
            <FormItem label="优化师" name="advertName" hidden > <Input/> </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label="建筑面积"
              name="constructionArea"
              rules={[{ required: true, message: '请输入' }]}
            >
              <InputNumber
                placeholder="请输入"
                style={{ width: '100%' }}
                step={0}
                min={0}
                precision={2}
              />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <FormItem label="备注" name="remark" >
              <TextArea placeholder="请输入" rows={2} maxLength={200} showCount />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </SDrawerOrModal>
  )
}

export default AddClueModal;
